import api from '../api';


export const createStore = async (projectId, storeDetails) => {
  const res = await api.post(`projects/${projectId}/stores`, storeDetails );
  return res.data;
};

export const updateStore = async (projectId, storeId, storeDetails) => {
  const res = await api.put(`projects/${projectId}/stores/${storeId}`, storeDetails );
  return res.data;
};

export const getStores = async (projectId, { pageIndex = 0, pageSize = 10, search = '', sorting = [] }) => {
  const response = await api.get(`/projects/${projectId}/stores`, {
    params: {
      page: pageIndex,
      size: pageSize,
      search,
      sort: JSON.stringify(sorting),
    },
  });

  const { stores, totalPages, totalItems } = response.data;

  return {
    data: stores,
    pageCount: totalPages,
    totalItems,
  };
};

export const deleteStore = async (projectId, storeCode) => {
  const res = await api.delete(`/projects/${projectId}/stores/${storeCode}`);
  return res.data;
};